import { useEffect, useRef } from 'react'
import type { Objective } from '../../domain/objective'
import { useI18n } from '../../i18n'
import { missionCopy } from '../missionCopy'

export type MissionOperation = 'complete' | 'close' | 'repeat'
interface Props {
  objective: Objective | null
  operation: MissionOperation
  saving: boolean
  error: string | null
  onClose: () => void
  onConfirm: () => Promise<void>
}
export const MissionLifecycleDialog = ({ objective, operation, saving, error, onClose, onConfirm }: Props) => {
  const ref = useRef<HTMLDialogElement>(null)
  const { language, copy: { common } } = useI18n()
  const c = missionCopy[language]
  useEffect(() => { if (objective && !ref.current?.open) ref.current?.showModal(); if (!objective && ref.current?.open) ref.current.close() }, [objective])
  const title = operation === 'complete' ? c.finish : operation === 'close' ? c.close : c.repeat
  const explanation = operation === 'complete' ? c.finishHelp : operation === 'close' ? c.closeHelp : c.repeatHelp
  return <dialog ref={ref} className="confirm-dialog mission-lifecycle" aria-labelledby="mission-operation-title" onCancel={(event) => { event.preventDefault(); if (!saving) onClose() }}><div className="sheet__body"><h2 id="mission-operation-title">{title}</h2><strong>{objective?.name}</strong><p>{explanation}</p>{error && <div className="error-message" role="alert">{error}</div>}<div className="mission-lifecycle__buttons"><button className="button button--ghost" type="button" disabled={saving} onClick={onClose}>{common.cancel}</button><button className="button button--primary" type="button" disabled={saving} onClick={() => void onConfirm()}>{saving ? common.saving : title}</button></div></div></dialog>
}
